import axios from "@axios";
import * as ep from "./endpoints";

export default class Service {
  static updateMainInfo(payload) {
    return axios.put(ep.PROJECT_BY_ID(payload.id), payload.form);
  }
  static storeProject(form) {
    return axios.post(ep.PROJECTS, form);
  }
  static deleteProject(id) {
    return axios.delete(ep.PROJECT_BY_ID(id));
  }
  static getProjectById(id) {
    return axios.get(ep.PROJECT_BY_ID(id)).then((res) => res.data);
  }
  static addnewRecord({ form, endpoint }) {
    return axios.post(endpoint, form);
  }
  static deleteRecord(endpoint) {
    return axios.delete(endpoint);
  }
  static updateRecord({ form, endpoint }) {
    return axios.put(endpoint, form);
  }
  static getRecords(endpoint) {
    return axios.get(endpoint).then((res) => res.data);
  }
  static fetchIOrganisationsMemberShips(id) {
    return axios.get(ep.IORGANISATIONS_MEMBERSHIPS_BY_ID(id)).then((res) => res.data);
  }
}
